import React from 'react';
import { useSelector } from 'react-redux';

const AllergensDescriptions = () => {
  const locale = useSelector(state => state.intl.locale);
  const path = locale === 'pl' ? 'allergens-descriptions_pl.pdf' : 'allergens-descriptions_en.pdf';
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.href = `/${path}`;
    }
  }, []);

  return null;
};
export default AllergensDescriptions;
